import styles from "./ProductView.module.css";

type Processo = {
  idProcesso: string;
  ordinamento: number;
  denominazione: string;
  descrizione: string;
  tipologia: number;
  link: string;
};

type Props = {
  onButtonClick: (processi: Processo[], title: string) => void;
  paga: any[];
  prenota: any[];
  iterDigitale: any[];
};
const BottoniProcessi = ({
  iterDigitale,
  prenota,
  paga,
  onButtonClick,
}: Props) => {
  // Funzione per gestire il click sui bottoni
  const handleButtonClick = (processi: Processo[], title: string) => {
    if (processi.length === 1) {
      window.open(processi[0].link, "_blank");
    } else {
      onButtonClick(processi, title);
    }
  };

  return (
    <div className={styles["stile-Bottoni"]}>
      <span>
        {iterDigitale.length > 0 && (
          <button
            onClick={() => handleButtonClick(iterDigitale, "Iter Digitale")}
            type="button"
            className="btn btn-primary btn-xs"
          >
            Avvia Iter Digitale
          </button>
        )}

        {prenota.length > 0 && (
          <button
            onClick={() => handleButtonClick(prenota, "Prenota Ora")}
            type="button"
            className="btn btn-primary btn-xs"
          >
            Prenota Ora
          </button>
        )}

        {paga.length > 0 && (
          <button
            onClick={() => handleButtonClick(paga, "Paga Online")}
            type="button"
            className="btn btn-primary btn-xs"
          >
            Paga Online
          </button>
        )}
      </span>
    </div>
  );
};

export default BottoniProcessi;
